module.exports = __webpack_public_path__ + "img/sggw-logo.b371f89a.svg";